export default "/images/vendor/geoportal-extensions-openlayers/src/OpenLayers/CSS/Controls/LayerSwitcher/GPshowLayersList.png?f376ff181a7eee5a5f8e17b73cb958ec";